import LocalizedStrings from "react-localization";
import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '../../app/store'

const strings = new LocalizedStrings({
  de: {
    priceCalculator: "Preisrechner",
    priceCalculatorDescrption: "Nutzen Sie das folgende Formular, um die Kosten für Ihren Transportauftrag zu berechnen.",
    loginGreeding: "Willkommen zurück, {UserName}",
    logout: "Abmelden",
    success: "Auftrag erfolgreich gesendet. Sollten Rückfragen bestehen werden wir uns bei Ihnen melden.",
    successRequest: "Anfrage erfolgreich gesendet. Wir werden uns sobald möglich bei Ihnen melden.",
    successTitle : "Auftrag gesendet",
    errorTitle : "Fehler beim Senden des Auftrags.",
    error:" Fehler beim Senden des Auftrags. Bitte wenden sie sich an info@cuno.gmbh.",
    userAlreadyExists: "Benutzer existiert bereits, bitte loggen Sie sich ein",
    recaptchaFailed: "Recaptcha-Überprüfung fehlgeschlagen, bitte aktualisieren Sie die Seite und versuchen Sie es später erneut.",
    unknownError: "Unbekannter Fehler. Bitte versuchen Sie es später erneut.",
    form:{
      valuemissing: "{ValueName} muss ausgefüllt werden",
      back: "Zurück",
      continue: "Weiter",
      haveAccount: "Sie haben bereits ein Kundenkonto? Einloggen",
      createAccount: "Sie haben noch keinen Account? Kundenkonto erstellen",
      login: "Login",
      contactData:{
        passwordConfirm: "Passwort bestätigen",
        passwordMatch: "Passwörter stimmen nicht überein",
        passwordLength: "Passwort muss mindestens 7 Zeichen lang sein",
        country: "Land",
        password: "Passwort",
        zip: "Postleitzahl",
        city: "Stadt",
        title: "Kontaktdaten",
        description: "Bitte geben Sie uns einige Informationen über Sie selbst.",
        descriptionLoggedIn: "Bitte überprüfen Sie ihre bestehenden Kontaktdaten.",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        phone: "Telefon",
        address: "Adresse",
        firstNamePlaceholder: "Alex",
        lastNamePlaceholder: "Muster",
        emailPlaceholder: "alex.muster@example.de",
        phonePlaceholder: "+49 123 4567890",
        addressPlaceholder: "Beispielweg 1, 12345 Beispielstadt",
      },
      pickupLocation:{
        title: "Abholort",
        description: "Bitte geben Sie uns einige Informationen zur Abholung des Fahrzeugs.",
        streetNumber: "Straße und Hausnummer",
        postalCode: "Postleitzahl",
        city: "Stadt",
        country: "Land",
        contactPerson: "Ansprechpartner vor Ort (optional)",
        companyName: "Firmenname (optional)",
        date: "Datum der Abholung",
        dateTooEarly: "Das frühste Abholdatum ist {minDate}.",
        time: "Uhrzeit (optional)",
        streetNumberPlaceholder:"Beispielstraße 1",
        postalCodePlaceholder:"12345",
        cityPlaceholder:"Beispielstadt",
        countryPlaceholder:"Deutschland",
        contactPersonPlaceholder:"Alex Muster (optional)",
        companyNamePlaceholder:"Beispiel GmbH (optional)",
        dateAndTimePlaceholder: "TT.MM.JJJJ HH:MM",
        email: "E-Mail (optional)",
        phone: "Telefon (optional)",
        mobile: "Mobil (optional)",
      },
      destinationLocation:{
        title: "Zielort",
        description: "Bitte geben Sie uns einige Informationen zum Zielort des Transports.",
        streetNumber: "Straße und Hausnummer",
        postalCode: "Postleitzahl",
        city: "Stadt",
        country: "Land",
        contactPerson: "Ansprechpartner vor Ort (optional)",
        companyName: "Firmenname (optional)",
        date: "Datum der Lieferung",
        dateTooEarly: "Das Lieferdatum darf nicht vor dem Abholdatum {minDate} liegen.",
        time: "Uhrzeit (optional)",
        streetNumberPlaceholder:"Beispielstraße 1",
        postalCodePlaceholder:"12345",
        cityPlaceholder:"Beispielstadt",
        countryPlaceholder:"Deutschland",
        contactPersonPlaceholder:"Alex Muster (optional)",
        companyNamePlaceholder:"Beispiel GmbH (optional)",
        dateAndTimePlaceholder: "TT.MM.JJJJ HH:MM",
      },
      vehicleDetails:{
        title: "Fahrzeugdetails",
        description: "Bitte geben Sie uns einige Informationen über das Fahrzeug.",
        vehicleMake: "Fahrzeugmarke",
        vehicleModel: "Fahrzeugmodell",
        vehicleColor: "Farbe",
        vehicleLicensePlate: "Kennzeichen",
        chassisNumber: "Fahrgestellnummer (optional)",
        chassisNumberPlaceholder: "Fahrgestellnummer eingeben",
        vehicleType: "Fahrzeugtyp",
        tireType: "Reifentyp",
        tireTypeSelect: "Unbekannt",
        tireTypeAllwetter: "Allwetter",
        tireTypeSommer: "Sommer",
        tireTypeWinter: "Winter",
        vehicleTypeOptions: {
          car: "Auto",
          van: "Transporter bis 3,5T",
          lightTruck: "Lkw bis 7,5T",
          truck: "Lkw ab 7,5T",
          motorcycle: "Motorrad",
          rv: "Wohnmobil",
          lightTrailer: "Anhänger bis 750kg",
          trailer: "Anhänger ab 750kg",
          bus: "Bus",
        },
        vehicleWorth: "Fahrzeugwert",
        vehicleWorthOptions:{
          pleasSelect:"Bitte auswählen",
          under80: "Weniger als 80.000€",
          over80: "Mehr als 80.000€",
        },
        vehicleRegistered:"Ist das Fahrzeug zugelassen?",
        vehicleAdditonalServices: "Zusätzliche Dienstleistungen",
        vehicleAdditonalServicesOptions: {
          redLicensePlates:"Rote Nummernschilder",
          basicDetailing:"Außenwäsche & Saugen",
          interiorDetailing:"Innenraumpflege",
          vehicleTeaching:"Fahrzeugeinweisung",
          vehicleStorage:"Fahrzeugeinlagerung"
        },
        vehicleColorPlaceHolder: "z.B. Blau",
        vehicleLicensePlatePlaceHolder: "z.B. B-AB 1234",
      },
      orderSummary: {
        title: "Zusammenfassung",
        description: "Sie haben alle notwendigen Daten eingegeben und können nun Ihren Auftrag erteilen. Bitte beachten Sie, dass der gezeigte Gesamtpreis eine Schätzung darstellt. Es können beispielsweise zusätzliche Kosten für Wartezeiten oder Tanken anfallen.",
        submitOrder: "Auftrag zahlungspflichtig abschicken",
        submitRequest: "Anfrage abschicken",
        createAccountNow: "Erstelle nun ein Kundenkonto, um die Bestellung abzuschließen.",
        requestOnly: "Preis auf Anfrage",
        emailVerification: "Es wurde ein Bestätigungs Link an Ihre E-Mail-Adresse gesendet. Bitte prüfen Sie auch Ihren Spam-Ordner. Warte auf E-Mail-Verifikation...",
        invoiceRecipientSameAsCustomer: "Rechnungsempfänger wie Auftraggeber",
        companyName: "Firma",
        contactPerson: "Ansprechpartner",
        streetNumber: "Straße und Hausnummer",
        zip: "PLZ",
        city: "Ort",
        country: "Land",
        name: "Name",
        customerNote: "Anmerkungen (optional)",
        customerNotePlaceholder: "Hier können Sie zusätzliche Informationen oder Wünsche für Ihren Auftrag hinterlassen...",
        details: "Details",
      },
      priceCalculation:{
        total: "Geschätzer Gesamtpreis*",
        item: "Position",
        amount: "Menge",
        itemTotal: "Gesamt (Brutto)",
        additionalMwst: "inkl. {amount} MwSt.",
        disclaimer: "Im Überführungspreis ist der Service eines elektronischen Fahrtprotokolls, eine genauen Fotodokumentation des Fahrzeuges sowie die Schadenaufnahme enthalten\n\n*Alle Preise sind freibleibend anfallender Tankkosten, Mautkosten, Kosten für Schmierstoffe und Wartezeiten. Regelungen zu den Wartezeiten entnehmen Sie bitte den AGB."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Fehlende Kontaktinformationen",
        message: "Sie haben keine Kontaktinformationen für den Abhol- oder Zielort angegeben. Möchten Sie diese nun eingeben?",
        yesText: "Jetzt eingeben",
        noText: "Ohne Eingabe fortfahren"
      }
    },
    faq:{
      isMandatoryOrder:{
        question: "Verpflichtet der Preisrechner zum Vertragsabschluss?",
        answer: "Am Ende des Preisrechners können Sie sich entscheiden, einen Auftrag einzureichen. Mit Einreichen des Auftrags gehen sie einen Vertragsabschluss ein, dieser ist verpflichtend. Die reine Nutzung des Preisrechners zur Abschätzung der Auftragskosten, ohne Einreichen eines Auftrags, ist freiwillig und verpflichtet nicht zum Vertragsabschluss."
      },
      moreHelpNeeded:{
        question:"Ich benötige weitere Hilfe oder Leistungen",
        answer:"Sie können uns jederzeit über  info@cuno.gmbh  oder unter 030 20 89 80 4-0 erreichen."
      }
    },
    cookieConsent:{
      title: "Cookie Hinweis",
      explanation: "Wir verwenden technisch notwendige Cookies auf dieser Seite. Des weiteren verwenden wir die Dienste von Recaptcha V3 (Google) zum Spamschutz. Weitere Informationen finden Sie in unserer Datenschutzerklärung und unserem Impressum.",
      accept: "Akzeptieren",
      decline: "Ablehnen",
    }
  },
  en: {
    priceCalculator: "Price Calculator",
    priceCalculatorDescrption: "Use the form below to calculate the cost of your transport request.",
    loginGreeding: "Welcome back, {UserName}",
    logout: "Logout",
    success: "Order sent successfully. If we have any questions, we will contact you.",
    successRequest: "Request successfully sent. We will contact you as soon as possible.",
    successTitle: "Order Sent",
    errorTitle: "Error Sending Order",
    error: "Error sending order. Please contact info@cuno.gmbh.",
    userAlreadyExists: "User already exists, please log in",
    recaptchaFailed: "Recaptcha challenge failed, please refresh the page and try again later.",
    unknownError: "Unknown error. Please try again later.",
    form: {
      valuemissing: "{ValueName} is required",
      back: "Back",
      continue: "Continue",
      haveAccount: "Already have a customer account? Log in",
      createAccount: "Don’t have an account yet? Create one",
      login: "Login",
      contactData: {
        passwordConfirm: "Confirm password",
        passwordMatch: "Passwords do not match",
        passwordLength: "Password must be at least 7 characters long",
        country: "Country",
        password: "Password",
        zip: "Postal code",
        city: "City",
        title: "Contact Information",
        description: "Please provide some information about yourself.",
        descriptionLoggedIn: "Please verify your existing contact information.",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        address: "Address",
        firstNamePlaceholder: "Taylor",
        lastNamePlaceholder: "Morgan",
        emailPlaceholder: "taylor.morgan@example.com",
        phonePlaceholder: "+1 202 555 0136",
        addressPlaceholder: "123 Oak St, Springfield, IL 62704",
      },
      pickupLocation: {
        title: "Pickup Location",
        description: "Please provide some information about vehicle pickup.",
        streetNumber: "Street and Number",
        postalCode: "Postal Code",
        city: "City",
        country: "Country",
        contactPerson: "Contact person on site (optional)",
        companyName: "Company name (optional)",
        date: "Pickup date",
        dateTooEarly: "The earliest pickup date is {minDate}.",
        time: "Time (optional)",
        streetNumberPlaceholder: "123 Example St",
        postalCodePlaceholder: "90210",
        cityPlaceholder: "Exampletown",
        countryPlaceholder: "Germany",
        contactPersonPlaceholder: "Jordan Taylor (optional)",
        companyNamePlaceholder: "Example Ltd. (optional)",
        dateAndTimePlaceholder: "DD/MM/YYYY HH:MM",
        emailPlaceholder: "person@example.com",
        phonePlaceholder: "+49 123 456789",
        mobilePlaceholder: "+49 123 456789",
        email: "E-Mail (optional)",
        phone: "Phone (optional)",
        mobile: "Mobile (optional)",
      },
      destinationLocation: {
        title: "Destination",
        description: "Please provide some information about the transport destination.",
        streetNumber: "Street and Number",
        postalCode: "Postal Code",
        city: "City",
        country: "Country",
        contactPerson: "Contact person on site (optional)",
        companyName: "Company name (optional)",
        date: "Delivery date",
        dateTooEarly: "The delivery date must not be before the pickup date {minDate}.",
        time: "Time (optional)",
        streetNumberPlaceholder: "123 Example St",
        postalCodePlaceholder: "90210",
        cityPlaceholder: "Exampletown",
        countryPlaceholder: "Germany",
        contactPersonPlaceholder: "Jordan Taylor (optional)",
        companyNamePlaceholder: "Example Ltd. (optional)",
        dateAndTimePlaceholder: "DD/MM/YYYY HH:MM",
      },
      vehicleDetails: {
        title: "Vehicle Details",
        description: "Please provide some information about the vehicle.",
        vehicleMake: "Make",
        vehicleModel: "Model",
        vehicleColor: "Color",
        vehicleLicensePlate: "License Plate",
        chassisNumber: "Chassis Number (optional)",
        chassisNumberPlaceholder: "Enter chassis number",
        vehicleType: "Vehicle Type",
        tireType: "Tire type",
        tireTypeSelect: "Unknown",
        tireTypeAllwetter: "All-weather",
        tireTypeSommer: "Summer",
        tireTypeWinter: "Winter",
        vehicleTypeOptions: {
          car: "Car",
          van: "Van up to 3.5 T",
          lightTruck: "Light Truck up to 7.5 T",
          truck: "Truck from 7.5 T",
          motorcycle: "Motorcycle",
          rv: "RV",
          lightTrailer: "Trailer up to 750 kg",
          trailer: "Trailer over 750 kg",
          bus: "Bus",
        },
        vehicleWorth: "Vehicle Value",
        vehicleWorthOptions: {
          pleasSelect: "Please select",
          under80: "Under €80,000",
          over80: "Over €80,000",
        },
        vehicleRegistered: "Is the vehicle registered?",
        vehicleAdditonalServices: "Additional services",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Red license plates",
          basicDetailing: "Exterior wash & vacuuming",
          interiorDetailing: "Interior cleaning",
          vehicleTeaching: "Vehicle briefing",
          vehicleStorage: "Vehicle storage",
        },
        vehicleColorPlaceHolder: "e.g. Blue",
        vehicleLicensePlatePlaceHolder: "e.g. ABC-1234",
      },
      orderSummary: {
        title: "Summary",
        description: "You have entered all necessary data and can now place your order. Please note, the shown total price is an estimate. Additional costs may apply for waiting times or fuel.",
        submitOrder: "Submit order (buy now)",
        createAccountNow: "Create a customer account now to complete your order.",
        requestOnly: "Price on request",
        submitRequest: "Submit inquiry",
        emailVerification: "A confirmation link has been sent to your email address. Please also check your spam folder. Waiting for email verification...",
        invoiceRecipientSameAsCustomer: "Invoice recipient same as customer",
        companyName: "Company",
        contactPerson: "Contact person",
        streetNumber: "Street and number",
        zip: "ZIP code",
        city: "City",
        country: "Country",
        name: "Name",
        customerNote: "Notes (optional)",
        customerNotePlaceholder: "You can leave additional information or requests for your order here...",
        details: "Details",
      },
      priceCalculation:{
        total: "Estimated Total Price*",
        item: "Item",
        amount: "Quantity",
        itemTotal: "Total (incl. VAT)",
        additionalMwst: "incl. {amount} VAT",
        disclaimer: "The transfer price includes the service of an electronic journey log, detailed photographic documentation of the vehicle as well as damage assessment\n\n*All prices are subject to additional fuel costs, toll costs, lubricant costs and waiting times. Please refer to the Terms and Conditions for regulations regarding waiting times."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Missing Contact Information",
        message: "You have not provided contact information for the pickup or destination location. Would you like to enter this information now?",
        yesText: "Enter now",
        noText: "Continue without entering"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "Does the price calculator obligate me to a contract?",
        answer: "At the end of the price calculator you can decide to submit an order. By submitting the order you enter into a binding contract. Using the price calculator alone to estimate costs, without submitting an order, is voluntary and not binding."
      },
      moreHelpNeeded: {
        question: "Need more help or services?",
        answer: "You can contact us anytime via info@cuno.gmbh or call +49 30 20 89 80 4-0."
      }
    },
    cookieConsent: {
      title: "Cookie Settings",
      explanation: "We use cookies to provide you with the best possible experience on our website. Some cookies are necessary, while others help us improve our services. We also use Recaptcha V3 (Google) to protect against spam. For more information, please see our Privacy Policy and Imprint.",
      accept: "Accept",
      decline: "Decline",
    }
  },
  tr: {
    priceCalculator: "Fiyat Hesaplayıcı",
    priceCalculatorDescrption: "Aşağıdaki formu kullanarak taşıma talebinizin maliyetini hesaplayabilirsiniz.",
    loginGreeding: "Tekrar hoş geldiniz, {UserName}",
    logout: "Çıkış Yap",
    success: "Sipariş başarıyla gönderildi. Herhangi bir sorumuz olursa sizinle iletişime geçeceğiz.",
    successRequest: "Talep başarıyla gönderildi. En kısa sürede sizinle iletişime geçeceğiz.",
    successTitle: "Sipariş Gönderildi",
    errorTitle: "Sipariş Gönderme Hatası",
    error: "Sipariş gönderilirken hata oluştu. Lütfen info@cuno.gmbh ile iletişime geçin.",
    userAlreadyExists: "Kullanıcı zaten mevcut, lütfen giriş yapın",
    recaptchaFailed: "Recaptcha doğrulaması başarısız, lütfen sayfayı yenileyip daha sonra tekrar deneyin.",
    unknownError: "Bilinmeyen hata. Lütfen daha sonra tekrar deneyin.",
    form: {
      valuemissing: "{ValueName} gerekli",
      back: "Geri",
      continue: "Devam",
      haveAccount: "Zaten bir hesabınız var mı? Giriş yapın",
      createAccount: "Henüz hesabınız yok mu? Hesap oluşturun",
      login: "Giriş",
      contactData: {
        passwordConfirm: "Şifreyi onayla",
        passwordMatch: "Şifreler eşleşmiyor",
        passwordLength: "Şifre en az 7 karakter uzunluğunda olmalıdır",
        country: "Ülke",
        password: "Şifre",
        zip: "Posta kodu",
        city: "Şehir",
        title: "İletişim Bilgileri",
        description: "Lütfen kendinizle ilgili bazı bilgileri verin.",
        descriptionLoggedIn: "Lütfen mevcut iletişim bilgilerinizi kontrol edin.",
        firstName: "Ad",
        lastName: "Soyad",
        email: "E‑posta",
        phone: "Telefon",
        address: "Adres",
        firstNamePlaceholder: "Deniz",
        lastNamePlaceholder: "Arslan",
        emailPlaceholder: "deniz.arslan@example.com.tr",
        phonePlaceholder: "+90 532 123 4567",
        addressPlaceholder: "Meşe Caddesi 10, 34430 Beyoğlu/İstanbul",
      },
      pickupLocation: {
        title: "Alış Yeri",
        description: "Lütfen aracın alınacağı yerle ilgili bazı bilgileri sağlayın.",
        streetNumber: "Cadde ve No",
        postalCode: "Posta Kodu",
        city: "Şehir",
        country: "Ülke",
        contactPerson: "Yerinde iletişim kişi (isteğe bağlı)",
        companyName: "Şirket adı (isteğe bağlı)",
        date: "Alış tarihi",
        dateTooEarly: "En erken alış tarihi {minDate}.",
        time: "Saat (isteğe bağlı)",
        streetNumberPlaceholder: "Örnek Sokak 1",
        postalCodePlaceholder: "34000",
        cityPlaceholder: "Örnekköy",
        countryPlaceholder: "Almanya",
        contactPersonPlaceholder: "Deniz Yılmaz (isteğe bağlı)",
        companyNamePlaceholder: "Örnek A.Ş. (isteğe bağlı)",
        dateAndTimePlaceholder: "GG.AA.YYYY SS:DD",
        email: "E-posta (isteğe bağlı)",
        phone: "Telefon (isteğe bağlı)",
        mobile: "Cep telefonu (isteğe bağlı)",
      },
      destinationLocation: {
        title: "Teslim Noktası",
        description: "Lütfen taşıma hedefiyle ilgili bazı bilgileri verin.",
        streetNumber: "Cadde ve No",
        postalCode: "Posta Kodu",
        city: "Şehir",
        country: "Ülke",
        contactPerson: "Yerinde iletişim kişi (isteğe bağlı)",
        companyName: "Şirket adı (isteğe bağlı)",
        date: "Teslim tarihi",
        dateTooEarly: "Teslim tarihi alış tarihinden {minDate} önce olamaz.",
        time: "Saat (isteğe bağlı)",
        streetNumberPlaceholder: "Örnek Sokak 1",
        postalCodePlaceholder: "34000",
        cityPlaceholder: "Örnekköy",
        countryPlaceholder: "Almanya",
        contactPersonPlaceholder: "Deniz Yılmaz (isteğe bağlı)",
        companyNamePlaceholder: "Örnek A.Ş. (isteğe bağlı)",
        dateAndTimePlaceholder: "GG.AA.YYYY SS:DD",
      },
      vehicleDetails: {
        title: "Araç Detayları",
        description: "Lütfen araçla ilgili bazı bilgileri sağlayın.",
        vehicleMake: "Marka",
        vehicleModel: "Model",
        vehicleColor: "Renk",
        vehicleLicensePlate: "Plaka",
        chassisNumber: "Şasi Numarası (isteğe bağlı)",
        chassisNumberPlaceholder: "Şasi numarası girin",
        vehicleType: "Araç Tipi",
        tireType: "Lastik türü",
        tireTypeSelect: "Bilinmiyor",
        tireTypeAllwetter: "Dört mevsim",
        tireTypeSommer: "Yaz",
        tireTypeWinter: "Kış",
        vehicleTypeOptions: {
          car: "Otomobil",
          van: "3,5 T kadar panelvan",
          lightTruck: "7,5 T kadar kamyonet",
          truck: "7,5 T'den büyük kamyon",
          motorcycle: "Motosiklet",
          rv: "Karavan",
          lightTrailer: "750 kg kadar römork",
          trailer: "750 kg üzeri römork",
          bus: "Otobüs",
        },
        vehicleWorth: "Araç Değeri",
        vehicleWorthOptions: {
          pleasSelect: "Lütfen seçin",
          under80: "80 000 € altında",
          over80: "80 000 € üstünde",
        },
        vehicleRegistered: "Araç kayıtlı mı?",
        vehicleAdditonalServices: "Ek hizmetler",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Kırmızı plakalar",
          basicDetailing: "Dış yıkama ve süpürme",
          interiorDetailing: "İç temizlik",
          vehicleTeaching: "Araç tanıtımı",
          vehicleStorage: "Araç depolama",
        },
        vehicleColorPlaceHolder: "ör. Mavi",
        vehicleLicensePlatePlaceHolder: "ör. 34 ABC 123",
      },
      orderSummary: {
        title: "Özet",
        description: "Gerekli tüm verileri girdiniz ve şimdi sipariş verebilirsiniz. Lütfen gösterilen toplam fiyatın bir tahmin olduğunu unutmayın. Bekleme süreleri veya yakıt için ek ücretler uygulanabilir.",
        submitOrder: "Siparişi gönder (ödeme ile)",
        submitRequest: "Talep gönder",
        createAccountNow: "Siparişi tamamlamak için şimdi bir müşteri hesabı oluşturun.",
        requestOnly: "Fiyat için iletişime geçiniz",
        emailVerification: "E-posta adresinize bir onay bağlantısı gönderildi. Lütfen spam klasörünüzü de kontrol edin. E-posta doğrulaması bekleniyor...",
        invoiceRecipientSameAsCustomer: "Fatura alıcısı müşteriyle aynı",
        companyName: "Şirket",
        contactPerson: "İrtibat kişisi",
        streetNumber: "Cadde ve numara",
        zip: "Posta kodu",
        city: "Şehir",
        country: "Ülke",
        name: "Ad",
        customerNote: "Notlar (isteğe bağlı)",
        customerNotePlaceholder: "Siparişiniz için ek bilgi veya isteklerinizi buraya yazabilirsiniz...",
        details: "Detaylar",
      },
      priceCalculation:{
        total: "Tahmini Toplam Fiyat*",
        item: "Kalem",
        amount: "Adet",
        itemTotal: "Toplam (KDV dahil)",
        additionalMwst: "dahil {amount} KDV",
        disclaimer: "Transfer fiyatında elektronik seyir günlüğü hizmeti, aracın detaylı fotoğraf belgelendirmesi ve hasar tespiti dahildir\n\n*Tüm fiyatlar yakıt maliyetleri, geçiş ücreti maliyetleri, yağlama maliyetleri ve bekleme süreleri ek maliyetlere tabidir. Bekleme süreleriyle ilgili düzenlemeler için lütfen Hüküm ve Koşullara bakınız."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Eksik İletişim Bilgileri",
        message: "Alış veya teslim yeri için iletişim bilgilerini belirtmediniz. Bu bilgileri şimdi girmek ister misiniz?",
        yesText: "Şimdi gir",
        noText: "Girmeden devam et"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "Fiyat hesaplayıcı sözleşme zorunlu kılar mı?",
        answer: "Fiyat hesaplayıcının sonunda bir sipariş göndermeyi seçebilirsiniz. Siparişi göndererek bağlayıcı bir sözleşme yapmış olursunuz. Sadece maliyeti tahmin etmek için hesaplayıcıyı kullanmak, sipariş göndermeden, gönüllüdür ve bağlayıcı değildir."
      },
      moreHelpNeeded: {
        question: "Daha fazla yardıma veya hizmete ihtiyacınız var mı?",
        answer: "Bize istediğiniz zaman info@cuno.gmbh üzerinden ya da +49 30 20 89 80 4‑0 numaralı telefonu arayarak ulaşabilirsiniz."
      }
    },
    cookieConsent: {
      title: "Çerez Ayarları",
      explanation: "Web sitemizde size en iyi deneyimi sunmak için çerezler kullanıyoruz. Bazı çerezler gereklidir, bazıları ise hizmetlerimizi geliştirmemize yardımcı olur. Ayrıca spam koruması için Recaptcha V3 (Google) hizmetini kullanıyoruz. Daha fazla bilgi için Gizlilik Politikamıza ve Yasal Uyarımıza göz atabilirsiniz.",
      accept: "Kabul Et",
      decline: "Reddet",
    }
  },
  it: {
    priceCalculator: "Calcolatore Prezzi",
    priceCalculatorDescrption: "Utilizzare il modulo seguente per calcolare il costo della richiesta di trasporto.",
    loginGreeding: "Bentornato/a, {UserName}",
    logout: "Disconnetti",
    success: "Ordine inviato con successo. In caso di domande ti contatteremo.",
    successRequest: "Richiesta inviata con successo. Ti contatteremo il prima possibile.",
    successTitle: "Ordine Inviato",
    errorTitle: "Errore nell'Invio dell'Ordine",
    error: "Errore nell'invio dell'ordine. Contatta info@cuno.gmbh.",
    userAlreadyExists: "L'utente esiste già, per favore accedi",
    recaptchaFailed: "Verifica Recaptcha fallita, per favore aggiorna la pagina e riprova più tardi.",
    unknownError: "Errore sconosciuto. Per favore riprova più tardi.",
    form: {
      valuemissing: "{ValueName} è obbligatorio",
      back: "Indietro",
      continue: "Avanti",
      haveAccount: "Hai già un account cliente? Accedi",
      createAccount: "Non hai ancora un account? Creane uno",
      login: "Login",
      contactData: {
        passwordConfirm: "Conferma password",
        passwordMatch: "Le password non coincidono",
        passwordLength: "La password deve contenere almeno 7 caratteri",
        country: "Paese",
        password: "Password",
        zip: "CAP",
        city: "Città",
        title: "Contatti",
        description: "Per favore forniscici alcune informazioni su di te.",
        descriptionLoggedIn: "Per favore verifica le tue informazioni di contatto esistenti.",
        firstName: "Nome",
        lastName: "Cognome",
        email: "E‑mail",
        phone: "Telefono",
        address: "Indirizzo",
        firstNamePlaceholder: "Andrea",
        lastNamePlaceholder: "Bianchi",
        emailPlaceholder: "andrea.bianchi@example.it",
        phonePlaceholder: "+39 347 123 4567",
        addressPlaceholder: "Via Verdi 1, 00100 Roma RM",
      },
      pickupLocation: {
        title: "Luogo di Ritiro",
        description: "Fornisci alcune informazioni sul ritiro del veicolo.",
        streetNumber: "Via e Numero",
        postalCode: "Codice Postale",
        city: "Città",
        country: "Paese",
        contactPerson: "Contatto in loco (opzionale)",
        companyName: "Nome azienda (opzionale)",
        date: "Data di ritiro",
        dateTooEarly: "La prima data di ritiro disponibile è {minDate}.",
        time: "Orario (opzionale)",
        streetNumberPlaceholder: "Via Esempio 1",
        postalCodePlaceholder: "00100",
        cityPlaceholder: "Esempiacittà",
        countryPlaceholder: "Germania",
        contactPersonPlaceholder: "Luca Rossi (facoltativo)",
        companyNamePlaceholder: "Esempio S.r.l. (facoltativo)",
        dateAndTimePlaceholder: "GG/MM/AAAA HH:MM",
        email: "Email (opzionale)",
        phone: "Telefono (opzionale)",
        mobile: "Cellulare (opzionale)",
      },
      destinationLocation: {
        title: "Destinazione",
        description: "Fornisci alcune informazioni sulla destinazione del trasporto.",
        streetNumber: "Via e Numero",
        postalCode: "Codice Postale",
        city: "Città",
        country: "Paese",
        contactPerson: "Contatto in loco (opzionale)",
        companyName: "Nome azienda (opzionale)",
        date: "Data di consegna",
        dateTooEarly: "La data di consegna non può essere prima della data di ritiro {minDate}.",
        time: "Orario (opzionale)",
        streetNumberPlaceholder: "Via Esempio 1",
        postalCodePlaceholder: "00100",
        cityPlaceholder: "Esempiacittà",
        countryPlaceholder: "Germania",
        contactPersonPlaceholder: "Luca Rossi (facoltativo)",
        companyNamePlaceholder: "Esempio S.r.l. (facoltativo)",
        dateAndTimePlaceholder: "GG/MM/AAAA HH:MM",
      },
      vehicleDetails: {
        title: "Dettagli Veicolo",
        description: "Fornisci alcune informazioni sul veicolo.",
        vehicleMake: "Marca",
        vehicleModel: "Modello",
        vehicleColor: "Colore",
        vehicleLicensePlate: "Targa",
        chassisNumber: "Numero di telaio (opzionale)",
        chassisNumberPlaceholder: "Inserisci numero di telaio",
        vehicleType: "Tipo di veicolo",
        tireType: "Tipo di pneumatico",
        tireTypeSelect: "Sconosciuto",
        tireTypeAllwetter: "Quattro stagioni",
        tireTypeSommer: "Estivi",
        tireTypeWinter: "Invernali",
        vehicleTypeOptions: {
          car: "Auto",
          van: "Furgone fino a 3,5 T",
          lightTruck: "Camion leggero fino a 7,5 T",
          truck: "Camion da 7,5 T in su",
          motorcycle: "Moto",
          rv: "Camper",
          lightTrailer: "Rimorchio fino a 750 kg",
          trailer: "Rimorchio oltre 750 kg",
          bus: "Autobus",
        },
        vehicleWorth: "Valore veicolo",
        vehicleWorthOptions: {
          pleasSelect: "Seleziona",
          under80: "Meno di € 80.000",
          over80: "Più di € 80.000",
        },
        vehicleRegistered: "Il veicolo è registrato?",
        vehicleAdditonalServices: "Servizi aggiuntivi",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Targhe rosse",
          basicDetailing: "Lavaggio esterno e aspirazione",
          interiorDetailing: "Pulizia interni",
          vehicleTeaching: "Briefing veicolo",
          vehicleStorage: "Deposito veicoli",
        },
        vehicleColorPlaceHolder: "es. Blu",
        vehicleLicensePlatePlaceHolder: "es. AB 123 CD",
      },
      orderSummary: {
        title: "Riepilogo",
        description: "Hai inserito tutti i dati necessari e ora puoi procedere con l'ordine. Nota che il prezzo mostrato è una stima. Potrebbero aggiungersi costi per attese o carburante.",
        submitOrder: "Invia ordine (pagamento)",
        submitRequest: "Invia richiesta",
        createAccountNow: "Crea ora un account cliente per completare l'ordine.",
        requestOnly: "Prezzo su richiesta",
        emailVerification: "È stato inviato un link di conferma al tuo indirizzo email. Controlla anche la cartella spam. In attesa di verifica email...",
        invoiceRecipientSameAsCustomer: "Destinatario fattura uguale al cliente",
        companyName: "Azienda",
        contactPerson: "Persona di contatto",
        streetNumber: "Via e numero civico",
        zip: "CAP",
        city: "Città",
        country: "Paese",
        name: "Nome",
        customerNote: "Note (facoltativo)",
        customerNotePlaceholder: "Puoi inserire qui informazioni aggiuntive o richieste per il tuo ordine...",
        details: "Dettagli",
      },
      priceCalculation: {
        total: "Prezzo totale stimato*",
        item: "Voce",
        amount: "Quantità",
        itemTotal: "Totale (IVA inclusa)",
        additionalMwst: "incl. {amount} IVA",
        disclaimer: "Il prezzo di trasferimento include il servizio di un registro elettronico di viaggio, documentazione fotografica dettagliata del veicolo e valutazione dei danni\n\n*Tutti i prezzi sono soggetti a costi aggiuntivi per carburante, pedaggi, lubrificanti e tempi di attesa. Per le normative sui tempi di attesa, consultare i Termini e Condizioni."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Informazioni di contatto mancanti",
        message: "Non hai fornito informazioni di contatto per il luogo di ritiro o destinazione. Vuoi inserire queste informazioni ora?",
        yesText: "Inserisci ora",
        noText: "Continua senza inserire"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "Il calcolatore di prezzi comporta l’obbligo di un contratto?",
        answer: "Alla fine del calcolatore di prezzi puoi decidere di inviare un ordine. Inviando l’ordine, accetti un contratto vincolante. Usare solo il calcolatore per stimare i costi, senza inviare un ordine, è volontario e non vincolante."
      },
      moreHelpNeeded: {
        question: "Hai bisogno di più aiuto o servizi?",
        answer: "Puoi contattarci in qualsiasi momento via info@cuno.gmbh o chiamando il +49 30 20 89 80 4‑0."
      }
    },
    cookieConsent: {
      title: "Impostazioni Cookie",
      explanation: "Utilizziamo i cookie per offrirti la migliore esperienza possibile sul nostro sito web. Alcuni cookie sono necessari, altri ci aiutano a migliorare i nostri servizi. Inoltre utilizziamo Recaptcha V3 (Google) per protezione dallo spam. Per maggiori informazioni, consulta la nostra Informativa sulla privacy e l’Impressum.",
      accept: "Accetta",
      decline: "Rifiuta",
    }
  },
  fr: {
    priceCalculator: "Calculateur de prix",
    priceCalculatorDescrption: "Utilisez le formulaire ci-dessous pour calculer le coût de votre demande de transport.",
    loginGreeding: "Bon retour, {UserName}",
    logout: "Se déconnecter",
    success: "Commande envoyée avec succès. Si nous avons des questions, nous vous contacterons.",
    successRequest: "Demande envoyée avec succès. Nous vous contacterons dès que possible.",
    successTitle: "Commande Envoyée",
    errorTitle: "Erreur lors de l'Envoi de la Commande",
    error: "Erreur lors de l'envoi de la commande. Veuillez contacter info@cuno.gmbh.",
    userAlreadyExists: "L'utilisateur existe déjà, veuillez vous connecter",
    recaptchaFailed: "Défi Recaptcha échoué, veuillez actualiser la page et réessayer plus tard.",
    unknownError: "Erreur inconnue. Veuillez réessayer plus tard.",
    form: {
      valuemissing: "{ValueName} est requis",
      back: "Précédent",
      continue: "Continuer",
      haveAccount: "Vous avez déjà un compte client ? Connectez-vous",
      createAccount: "Vous n’avez pas encore de compte ? Créez-en un",
      login: "Connexion",
      contactData: {
        passwordConfirm: "Confirmer le mot de passe",
        passwordMatch: "Les mots de passe ne correspondent pas",
        passwordLength: "Le mot de passe doit contenir au moins 7 caractères",
        country: "Pays",
        password: "Mot de passe",
        zip: "Code postal",
        city: "Ville",
        title: "Coordonnées",
        description: "Veuillez nous fournir quelques informations vous concernant.",
        descriptionLoggedIn: "Veuillez vérifier vos coordonnées existantes.",
        firstName: "Prénom",
        lastName: "Nom",
        email: "E‑mail",
        phone: "Téléphone",
        address: "Adresse",
        firstNamePlaceholder: "Camille",
        lastNamePlaceholder: "Moreau",
        emailPlaceholder: "camille.moreau@example.fr",
        phonePlaceholder: "+33 6 12 34 56 78",
        addressPlaceholder: "10 Avenue de la République, 75011 Paris",
      },
      pickupLocation: {
        title: "Lieu de prise en charge",
        description: "Veuillez nous fournir des informations sur le lieu de prise en charge du véhicule.",
        streetNumber: "Rue et numéro",
        postalCode: "Code postal",
        city: "Ville",
        country: "Pays",
        contactPerson: "Personne de contact sur place (optionnel)",
        companyName: "Nom de l’entreprise (optionnel)",
        date: "Date de prise en charge",
        dateTooEarly: "La première date de prise en charge disponible est le {minDate}.",
        time: "Heure (optionnel)",
        streetNumberPlaceholder: "1 Rue Exemple",
        postalCodePlaceholder: "75001",
        cityPlaceholder: "Villeexemple",
        countryPlaceholder: "Allemagne",
        contactPersonPlaceholder: "Camille Dupont (optionnel)",
        companyNamePlaceholder: "Exemple SARL (optionnel)",
        dateAndTimePlaceholder: "JJ/MM/AAAA HH:MM",
        email: "E-mail (optionnel)",
        phone: "Téléphone (optionnel)",
        mobile: "Portable (optionnel)",
      },
      destinationLocation: {
        title: "Destination",
        description: "Veuillez nous fournir des informations sur la destination du transport.",
        streetNumber: "Rue et numéro",
        postalCode: "Code postal",
        city: "Ville",
        country: "Pays",
        contactPerson: "Personne de contact sur place (optionnel)",
        companyName: "Nom de l’entreprise (optionnel)",
        date: "Date de livraison",
        dateTooEarly: "La date de livraison ne doit pas être antérieure à la date de prise en charge {minDate}.",
        time: "Heure (optionnel)",
        streetNumberPlaceholder: "1 Rue Exemple",
        postalCodePlaceholder: "75001",
        cityPlaceholder: "Villeexemple",
        countryPlaceholder: "Allemagne",
        contactPersonPlaceholder: "Camille Dupont (optionnel)",
        companyNamePlaceholder: "Exemple SARL (optionnel)",
        dateAndTimePlaceholder: "JJ/MM/AAAA HH:MM",
      },
      vehicleDetails: {
        title: "Détails du véhicule",
        description: "Veuillez nous fournir des informations sur le véhicule.",
        vehicleMake: "Marque",
        vehicleModel: "Modèle",
        vehicleColor: "Couleur",
        vehicleLicensePlate: "Plaque d'immatriculation",
        chassisNumber: "Numéro de châssis (optionnel)",
        chassisNumberPlaceholder: "Entrez le numéro de châssis",
        vehicleType: "Type de véhicule",
        tireType: "Type de pneu",
        tireTypeSelect: "Inconnu",
        tireTypeAllwetter: "Toutes saisons",
        tireTypeSommer: "Été",
        tireTypeWinter: "Hiver",
        vehicleTypeOptions: {
          car: "Voiture",
          van: "Camionnette jusqu’à 3,5 T",
          lightTruck: "Camion léger jusqu’à 7,5 T",
          truck: "Camion à partir de 7,5 T",
          motorcycle: "Moto",
          rv: "Camping‑car",
          lightTrailer: "Remorque jusqu’à 750 kg",
          trailer: "Remorque plus de 750 kg",
          bus: "Autobus",
        },
        vehicleWorth: "Valeur du véhicule",
        vehicleWorthOptions: {
          pleasSelect: "Veuillez sélectionner",
          under80: "Moins de 80 000 €",
          over80: "Plus de 80 000 €",
        },
        vehicleRegistered: "Le véhicule est-il immatriculé?",
        vehicleAdditonalServices: "Services supplémentaires",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Plaques rouges",
          basicDetailing: "Lavage extérieur et aspiration",
          interiorDetailing: "Nettoyage intérieur",
          vehicleTeaching: "Briefing du véhicule",
          vehicleStorage: "Stockage du véhicule",
        },
        vehicleColorPlaceHolder: "ex. Bleu",
        vehicleLicensePlatePlaceHolder: "ex. AB-123-CD",
      },
      orderSummary: {
        title: "Résumé",
        description: "Vous avez saisi toutes les données nécessaires et pouvez maintenant passer commande. Veuillez noter que le prix total affiché est une estimation. Des coûts supplémentaires peuvent s'appliquer pour les temps d'attente ou le carburant.",
        submitOrder: "Envoyer la commande (payant)",
        submitRequest: "Envoyer une demande",
        createAccountNow: "Créez dès maintenant un compte client pour finaliser la commande.",
        requestOnly: "Prix sur demande",
        emailVerification: "Un lien de confirmation a été envoyé à votre adresse e-mail. Veuillez également vérifier votre dossier spam. En attente de vérification...",
        invoiceRecipientSameAsCustomer: "Destinataire de facture identique au client",
        companyName: "Entreprise",
        contactPerson: "Personne de contact",
        streetNumber: "Rue et numéro",
        zip: "Code postal",
        city: "Ville",
        country: "Pays",
        name: "Nom",
        customerNote: "Notes (optionnel)",
        customerNotePlaceholder: "Vous pouvez laisser ici des informations supplémentaires ou des demandes pour votre commande...",
        details: "Détails",
      },
      priceCalculation: {
        total: "Prix total estimé*",
        item: "Article",
        amount: "Quantité",
        itemTotal: "Total (TTC)",
        additionalMwst: "incl. {amount} TVA",
        disclaimer: "Le prix de transfert comprend le service d'un journal de voyage électronique, une documentation photographique détaillée du véhicule ainsi qu'une évaluation des dommages\n\n*Tous les prix sont sujets à des coûts supplémentaires de carburant, péages, lubrifiants et temps d'attente. Veuillez vous référer aux Conditions Générales pour les réglementations concernant les temps d'attente."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Informations de contact manquantes",
        message: "Vous n'avez pas fourni d'informations de contact pour le lieu de prise en charge ou de destination. Souhaitez-vous saisir ces informations maintenant ?",
        yesText: "Saisir maintenant",
        noText: "Continuer sans saisir"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "Le calculateur de prix m’oblige-t-il à un contrat?",
        answer: "À la fin du calculateur vous pouvez décider d’envoyer une commande. En envoyant la commande, vous concluez un contrat contraignant. L’utilisation du calculateur uniquement pour estimer les coûts, sans envoyer de commande, est volontaire et non contraignante."
      },
      moreHelpNeeded: {
        question: "Besoin de plus d’aide ou de services ?",
        answer: "Vous pouvez nous contacter à tout moment via info@cuno.gmbh ou en appelant le +49 30 20 89 80 4‑0."
      }
    },
    cookieConsent: {
      title: "Paramètres des cookies",
      explanation: "Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur notre site. Certains cookies sont nécessaires, d'autres nous aident à améliorer nos services. Nous utilisons également Recaptcha V3 (Google) pour la protection contre le spam. Pour plus d'informations, consultez notre politique de confidentialité et nos mentions légales.",
      accept: "Accepter",
      decline: "Refuser",
    }
  },
  pl: {
    priceCalculator: "Kalkulator cen",
    priceCalculatorDescrption: "Użyj poniższego formularza, aby obliczyć koszty Twojego zlecenia transportowego.",
    loginGreeding: "Witamy ponownie, {UserName}",
    logout: "Wyloguj się",
    success: "Zamówienie zostało pomyślnie wysłane. W razie pytań skontaktujemy się z Tobą.",
    successRequest: "Zapytanie zostało pomyślnie wysłane. Skontaktujemy się z Tobą tak szybko jak to możliwe.",
    successTitle: "Zamówienie Wysłane",
    errorTitle: "Błąd Wysyłania Zamówienia",
    error: "Błąd podczas wysyłania zamówienia. Skontaktuj się z info@cuno.gmbh.",
    userAlreadyExists: "Użytkownik już istnieje, proszę się zalogować",
    recaptchaFailed: "Weryfikacja Recaptcha nie powiodła się, proszę odświeżyć stronę i spróbować ponownie później.",
    unknownError: "Nieznany błąd. Proszę spróbować ponownie później.",
    form: {
      valuemissing: "{ValueName} jest wymagane",
      back: "Wstecz",
      continue: "Kontynuuj",
      haveAccount: "Masz już konto klienta? Zaloguj się",
      createAccount: "Nie masz jeszcze konta? Utwórz je",
      login: "Logowanie",
      contactData: {
        passwordConfirm: "Potwierdź hasło",
        passwordMatch: "Hasła się nie zgadzają",
        passwordLength: "Hasło musi mieć co najmniej 7 znaków",
        country: "Kraj",
        password: "Hasło",
        zip: "Kod pocztowy",
        city: "Miasto",
        title: "Dane kontaktowe",
        description: "Proszę podać nam kilka informacji o sobie.",
        descriptionLoggedIn: "Proszę sprawdzić istniejące dane kontaktowe.",
        firstName: "Imię",
        lastName: "Nazwisko",
        email: "E-mail",
        phone: "Telefon",
        address: "Adres",
        firstNamePlaceholder: "Alex",
        lastNamePlaceholder: "Nowak",
        emailPlaceholder: "alex.nowak@example.pl",
        phonePlaceholder: "+48 512 345 678",
        addressPlaceholder: "ul. Klonowa 1, 00-001 Warszawa",
      },
      pickupLocation: {
        title: "Miejsce odbioru",
        description: "Proszę podać nam informacje na temat odbioru pojazdu.",
        streetNumber: "Ulica i numer",
        postalCode: "Kod pocztowy",
        city: "Miasto",
        country: "Kraj",
        contactPerson: "Osoba kontaktowa na miejscu (opcjonalnie)",
        companyName: "Nazwa firmy (opcjonalnie)",
        date: "Data odbioru",
        dateTooEarly: "Najwcześniejsza data odbioru to {minDate}.",
        time: "Godzina (opcjonalnie)",
        streetNumberPlaceholder: "ul. Przykładowa 1",
        postalCodePlaceholder: "00-001",
        cityPlaceholder: "Przykładowo",
        countryPlaceholder: "Niemcy",
        contactPersonPlaceholder: "Oliwia Kowalski (opcjonalnie)",
        companyNamePlaceholder: "Przykład Sp. z o.o. (opcjonalnie)",
        dateAndTimePlaceholder: "DD.MM.RRRR GG:MM",
        email: "E-mail (opcjonalnie)",
        phone: "Telefon (opcjonalnie)",
        mobile: "Komórka (opcjonalnie)",
      },
      destinationLocation: {
        title: "Miejsce docelowe",
        description: "Proszę podać nam informacje o miejscu docelowym transportu.",
        streetNumber: "Ulica i numer",
        postalCode: "Kod pocztowy",
        city: "Miasto",
        country: "Kraj",
        contactPerson: "Osoba kontaktowa na miejscu (opcjonalnie)",
        companyName: "Nazwa firmy (opcjonalnie)",
        date: "Data dostawy",
        dateTooEarly: "Data dostawy nie może być wcześniejsza niż data odbioru {minDate}.",
        time: "Godzina (opcjonalnie)",
        streetNumberPlaceholder: "ul. Przykładowa 1",
        postalCodePlaceholder: "00-001",
        cityPlaceholder: "Przykładowo",
        countryPlaceholder: "Niemcy",
        contactPersonPlaceholder: "Oliwia Kowalski (opcjonalnie)",
        companyNamePlaceholder: "Przykład Sp. z o.o. (opcjonalnie)",
        dateAndTimePlaceholder: "DD.MM.RRRR GG:MM",
      },
      vehicleDetails: {
        title: "Szczegóły pojazdu",
        description: "Proszę podać nam informacje o pojeździe.",
        vehicleMake: "Marka",
        vehicleModel: "Model",
        vehicleColor: "Kolor",
        vehicleLicensePlate: "Tablica rejestracyjna",
        chassisNumber: "Numer VIN (opcjonalnie)",
        chassisNumberPlaceholder: "Wprowadź numer VIN",
        vehicleType: "Typ pojazdu",
        tireType: "Rodzaj opon",
        tireTypeSelect: "Nieznany",
        tireTypeAllwetter: "Całoroczne",
        tireTypeSommer: "Letnie",
        tireTypeWinter: "Zimowe",
        vehicleTypeOptions: {
          car: "Samochód",
          van: "Van do 3,5 T",
          lightTruck: "Lekki truck do 7,5 T",
          truck: "Ciężarówka od 7,5 T",
          motorcycle: "Motocykl",
          rv: "Kamper",
          lightTrailer: "Przyczepa do 750 kg",
          trailer: "Przyczepa powyżej 750 kg",
          bus: "Autobus",
        },
        vehicleWorth: "Wartość pojazdu",
        vehicleWorthOptions: {
          pleasSelect: "Proszę wybrać",
          under80: "Poniżej 80 000 €",
          over80: "Powyżej 80 000 €",
        },
        vehicleRegistered: "Czy pojazd jest zarejestrowany?",
        vehicleAdditonalServices: "Dodatkowe usługi",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Czerwone tablice",
          basicDetailing: "Mycie zewnętrzne i odkurzanie",
          interiorDetailing: "Sprzątanie wnętrza",
          vehicleTeaching: "Instruktaż pojazdu",
          vehicleStorage: "Przechowywanie pojazdu",
        },
        vehicleColorPlaceHolder: "np. Niebieski",
        vehicleLicensePlatePlaceHolder: "np. WX 1234A",
      },
      orderSummary: {
        title: "Podsumowanie",
        description: "Wprowadziłeś wszystkie potrzebne dane i możesz teraz złożyć zamówienie. Pamiętaj, że wyświetlana cena jest szacunkowa. Mogą pojawić się dodatkowe koszty za czas oczekiwania lub paliwo.",
        submitOrder: "Złóż zamówienie (płatne)",
        submitRequest: "Wyślij zapytanie",
        createAccountNow: "Utwórz teraz konto klienta, aby dokończyć zamówienie.",
        requestOnly: "Cena na zapytanie",
        emailVerification: "Link potwierdzający został wysłany na Twój adres e-mail. Sprawdź również folder spam. Oczekiwanie na weryfikację...",
        invoiceRecipientSameAsCustomer: "Odbiorca faktury taki sam jak klient",
        companyName: "Firma",
        contactPerson: "Osoba kontaktowa",
        streetNumber: "Ulica i numer",
        zip: "Kod pocztowy",
        city: "Miasto",
        country: "Kraj",
        name: "Imię i nazwisko",
        customerNote: "Uwagi (opcjonalnie)",
        customerNotePlaceholder: "Możesz tutaj pozostawić dodatkowe informacje lub życzenia dotyczące zamówienia...",
        details: "Szczegóły",
      },
      priceCalculation: {
        total: "Szacowany całkowity koszt*",
        item: "Pozycja",
        amount: "Ilość",
        itemTotal: "Razem (z VAT)",
        additionalMwst: "w tym {amount} VAT",
        disclaimer: "Cena transportu obejmuje usługę elektronicznego dziennika podróży, szczegółową dokumentację fotograficzną pojazdu oraz ocenę szkód\n\n*Wszystkie ceny podlegają dodatkowym kosztom paliwa, opłat drogowych, smarów i czasu oczekiwania. Regulacje dotyczące czasu oczekiwania znajdziesz w Regulaminie."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Brakujące dane kontaktowe",
        message: "Nie podałeś informacji kontaktowych dla miejsca odbioru lub dostawy. Czy chcesz wprowadzić te informacje teraz?",
        yesText: "Wprowadź teraz",
        noText: "Kontynuuj bez wprowadzania"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "Czy kalkulator cen zobowiązuje do zawarcia umowy?",
        answer: "Na końcu kalkulatora cen możesz zdecydować się na złożenie zamówienia. Składając je, zawierasz wiążącą umowę. Samo korzystanie z kalkulatora wyłącznie w celu oszacowania kosztów, bez składania zamówienia, jest dobrowolne i nie wiąże.",
      },
      moreHelpNeeded: {
        question: "Potrzebujesz więcej pomocy lub usług?",
        answer: "Możesz się z nami skontaktować w dowolnym momencie poprzez info@cuno.gmbh lub dzwoniąc pod +49 30 20 89 80 4‑0."
      }
    },
    cookieConsent: {
      title: "Ustawienia plików cookie",
      explanation: "Używamy plików cookie, aby zapewnić jak najlepsze wrażenia z korzystania z naszej strony. Niektóre są niezbędne, inne pomagają nam ulepszać nasze usługi. Korzystamy również z Recaptcha V3 (Google) w celu ochrony przed spamem. Więcej informacji znajdziesz w naszej Polityce prywatności i Impressum.",
      accept: "Akceptuj",
      decline: "Odrzuć",
    }
  },
  ru: {
    priceCalculator: "Калькулятор цен",
    priceCalculatorDescrption: "Используйте форму ниже, чтобы рассчитать стоимость вашего транспортного заказа.",
    loginGreeding: "С возвращением, {UserName}",
    logout: "Выйти",
    success: "Заказ успешно отправлен. Если возникнут вопросы, мы с вами свяжемся.",
    successRequest: "Запрос успешно отправлен. Мы свяжемся с вами как можно скорее.",
    successTitle: "Заказ Отправлен",
    errorTitle: "Ошибка при Отправке Заказа",
    error: "Ошибка при отправке заказа. Свяжитесь с info@cuno.gmbh.",
    userAlreadyExists: "Пользователь уже существует, пожалуйста, войдите в систему",
    recaptchaFailed: "Проверка Recaptcha не удалась, пожалуйста, обновите страницу и повторите попытку позже.",
    unknownError: "Неизвестная ошибка. Пожалуйста, повторите попытку позже.",
    form: {
      valuemissing: "{ValueName} обязательно",
      back: "Назад",
      continue: "Продолжить",
      haveAccount: "Уже есть учетная запись? Войти",
      createAccount: "Еще нет учетной записи? Создайте ее",
      login: "Вход",
      contactData: {
        passwordConfirm: "Подтвердите пароль",
        passwordMatch: "Пароли не совпадают",
        passwordLength: "Пароль должен содержать не менее 7 символов",
        country: "Страна",
        password: "Пароль",
        zip: "Почтовый индекс",
        city: "Город",
        title: "Контактная информация",
        description: "Пожалуйста, предоставьте информацию о себе.",
        descriptionLoggedIn: "Пожалуйста, проверьте вашу существующую контактную информацию.",
        firstName: "Имя",
        lastName: "Фамилия",
        email: "Электронная почта",
        phone: "Телефон",
        address: "Адрес",
        firstNamePlaceholder: "Саша",
        lastNamePlaceholder: "Смирнов",
        emailPlaceholder: "sasha.smirnov@example.ru",
        phonePlaceholder: "+7 912 345-67-89",
        addressPlaceholder: "ул. Лесная, д. 12, Москва, 119019",
      },
      pickupLocation: {
        title: "Место забора",
        description: "Пожалуйста, укажите информацию о месте забора транспортного средства.",
        streetNumber: "Улица и номер",
        postalCode: "Почтовый индекс",
        city: "Город",
        country: "Страна",
        contactPerson: "Контакт на месте (необязательно)",
        companyName: "Название компании (необязательно)",
        date: "Дата забора",
        dateTooEarly: "Самая ранняя дата забора {minDate}.",
        time: "Время (необязательно)",
        streetNumberPlaceholder: "ул. Примерная, д. 1",
        postalCodePlaceholder: "101000",
        cityPlaceholder: "Примерград",
        countryPlaceholder: "Германия",
        contactPersonPlaceholder: "Саша Смирнов (необязательно)",
        companyNamePlaceholder: "Пример ООО (необязательно)",
        dateAndTimePlaceholder: "ДД.ММ.ГГГГ ЧЧ:ММ",
        email: "Эл. почта (необязательно)",
        phone: "Телефон (необязательно)",
        mobile: "Мобильный (необязательно)",
      },
      destinationLocation: {
        title: "Место назначения",
        description: "Пожалуйста, предоставьте информацию о месте назначения транспортировки.",
        streetNumber: "Улица и номер",
        postalCode: "Почтовый индекс",
        city: "Город",
        country: "Страна",
        contactPerson: "Контакт на месте (необязательно)",
        companyName: "Название компании (необязательно)",
        date: "Дата доставки",
        dateTooEarly: "Дата доставки не может быть раньше даты забора {minDate}.",
        time: "Время (необязательно)",
        streetNumberPlaceholder: "ул. Примерная, д. 1",
        postalCodePlaceholder: "101000",
        cityPlaceholder: "Примерград",
        countryPlaceholder: "Германия",
        contactPersonPlaceholder: "Саша Смирнов (необязательно)",
        companyNamePlaceholder: "Пример ООО (необязательно)",
        dateAndTimePlaceholder: "ДД.ММ.ГГГГ ЧЧ:ММ",
      },
      vehicleDetails: {
        title: "Данные об автомобиле",
        description: "Пожалуйста, предоставьте информацию о транспортном средстве.",
        vehicleMake: "Марка",
        vehicleModel: "Модель",
        vehicleColor: "Цвет",
        vehicleLicensePlate: "Номерной знак",
        chassisNumber: "Номер шасси (необязательно)",
        chassisNumberPlaceholder: "Введите номер шасси",
        vehicleType: "Тип транспортного средства",
        tireType: "Тип шин",
        tireTypeSelect: "Неизвестно",
        tireTypeAllwetter: "Всесезонные",
        tireTypeSommer: "Летние",
        tireTypeWinter: "Зимние",
        vehicleTypeOptions: {
          car: "Легковой автомобиль",
          van: "Фургон до 3,5 т",
          lightTruck: "Легкий грузовик до 7,5 т",
          truck: "Грузовик от 7,5 т",
          motorcycle: "Мотоцикл",
          rv: "Дом на колёсах",
          lightTrailer: "Прицеп до 750 кг",
          trailer: "Прицеп свыше 750 кг",
          bus: "Автобус",
        },
        vehicleWorth: "Стоимость автомобиля",
        vehicleWorthOptions: {
          pleasSelect: "Пожалуйста, выберите",
          under80: "Менее 80 000 €",
          over80: "Более 80 000 €",
        },
        vehicleRegistered: "Автомобиль зарегистрирован?",
        vehicleAdditonalServices: "Дополнительные услуги",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Красные номера",
          basicDetailing: "Внешняя мойка и пылесос",
          interiorDetailing: "Уборка салона",
          vehicleTeaching: "Инструктаж по автомобилю",
          vehicleStorage: "Хранение автомобиля",
        },
        vehicleColorPlaceHolder: "напр. Синий",
        vehicleLicensePlatePlaceHolder: "напр. А123ВС 77",
      },
      orderSummary: {
        title: "Сводка",
        description: "Вы ввели все необходимые данные и теперь можете разместить заказ. Обратите внимание, что указанная сумма является приблизительной. Могут быть дополнительные сборы за ожидание или топливо.",
        submitOrder: "Отправить заказ (оплата)",
        submitRequest: "Отправить запрос",
        createAccountNow: "Создайте учетную запись, чтобы завершить заказ.",
        requestOnly: "Цена по запросу",
        emailVerification: "Ссылка для подтверждения была отправлена на ваш email. Проверьте также папку спам. Ожидание подтверждения...",
        invoiceRecipientSameAsCustomer: "Получатель счета такой же, как замовник",
        companyName: "Компания",
        contactPerson: "Контактное лицо",
        streetNumber: "Улица и номер",
        zip: "Почтовый индекс",
        city: "Город",
        country: "Страна",
        name: "Имя",
        customerNote: "Примечания (необязательно)",
        customerNotePlaceholder: "Здесь вы можете оставить дополнительную информацию или пожелания к вашему заказу...",
        details: "Детали",
      },
      priceCalculation: {
        total: "Ориентировочная итоговая цена*",
        item: "Позиция",
        amount: "Количество",
        itemTotal: "Итого (с НДС)",
        additionalMwst: "включая {amount} НДС",
        disclaimer: "В стоимость перегона входит услуга электронного журнала поездки, подробная фотодокументация автомобиля, а также оценка повреждений\n\n*Все цены не включают дополнительные расходы на топливо, дорожные сборы, смазочные материалы и время ожидания. Правила по времени ожидания см. в Условиях предоставления услуг."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Недостающая контактная информация",
        message: "Вы не указали контактную информацию для места забора или доставки. Хотите ввести эту информацию сейчас?",
        yesText: "Ввести сейчас",
        noText: "Продолжить без ввода"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "Обязывает ли калькулятор цен к заключению договора?",
        answer: "В конце калькулятора цен вы можете решить отправить заказ. Отправляя заказ, вы заключаете обязательный договор. Использование калькулятора только для оценки стоимости, без отправки заказа, является добровольным и не обязательным.",
      },
      moreHelpNeeded: {
        question: "Нужна дополнительная помощь или услуги?",
        answer: "Вы можете связаться с нами в любое время по адресу info@cuno.gmbh или по телефону +49 30 20 89 80 4‑0."
      }
    },
    cookieConsent: {
      title: "Настройки файлов cookie",
      explanation: "Мы используем файлы cookie, чтобы обеспечить вам наилучший опыт на нашем сайте. Некоторые файлы cookie необходимы, другие помогают нам улучшать наши услуги. Также мы используем Recaptcha V3 (Google) для защиты от спама. Подробнее читайте в нашей Политике конфиденциальности и Юридической информации.",
      accept: "Принять",
      decline: "Отклонить",
    }
  },
  uk: {
    priceCalculator: "Калькулятор цін",
    priceCalculatorDescrption: "Використовуйте форму нижче, щоб розрахувати вартість вашого транспортного замовлення.",
    loginGreeding: "Ласкаво просимо назад, {UserName}",
    logout: "Вийти",
    success: "Замовлення успішно надіслано. Якщо виникнуть питання, ми з вами зв’яжемося.",
    successRequest: "Запит успішно надіслано. Ми зв'яжемося з вами якнайшвидше.",
    successTitle: "Замовлення Надіслано",
    errorTitle: "Помилка при Надсиланні Замовлення",
    error: "Помилка при надсиланні замовлення. Зв'яжіться з info@cuno.gmbh.",
    userAlreadyExists: "Користувач вже існує, будь ласка, увійдіть до системи",
    recaptchaFailed: "Перевірка Recaptcha не вдалася, будь ласка, оновіть сторінку та спробуйте пізніше.",
    unknownError: "Невідома помилка. Будь ласка, спробуйте пізніше.",
    form: {
      valuemissing: "{ValueName} є обов'язковим",
      back: "Назад",
      continue: "Продовжити",
      haveAccount: "Вже маєте обліковий запис? Увійти",
      createAccount: "Ще не маєте облікового запису? Створіть його",
      login: "Вхід",
      contactData: {
        passwordConfirm: "Підтвердьте пароль",
        passwordMatch: "Паролі не збігаються",
        passwordLength: "Пароль має містити щонайменше 7 символів",
        country: "Країна",
        password: "Пароль",
        zip: "Поштовий індекс",
        city: "Місто",
        title: "Контактна інформація",
        description: "Будь ласка, надайте інформацію про себе.",
        descriptionLoggedIn: "Будь ласка, перевірте вашу існуючу контактну інформацію.",
        firstName: "Ім'я",
        lastName: "Прізвище",
        email: "Електронна пошта",
        phone: "Телефон",
        address: "Адреса",
        firstNamePlaceholder: "Саша",
        lastNamePlaceholder: "Шевченко",
        emailPlaceholder: "sasha.shevchenko@example.ua",
        phonePlaceholder: "+380 67 123 4567",
        addressPlaceholder: "вул. Лісова, 10, Київ, 01001",
      },
      pickupLocation: {
        title: "Місце забору",
        description: "Будь ласка, надайте інформацію про місце забору транспортного засобу.",
        streetNumber: "Вулиця та номер",
        postalCode: "Поштовий індекс",
        city: "Місто",
        country: "Країна",
        contactPerson: "Контактна особа на місці (необов'язково)",
        companyName: "Назва компанії (необов'язково)",
        date: "Дата забору",
        dateTooEarly: "Найраніша дата забору {minDate}.",
        time: "Час (необов'язково)",
        streetNumberPlaceholder: "вул. Прикладна, 1",
        postalCodePlaceholder: "01001",
        cityPlaceholder: "Прикладоград",
        countryPlaceholder: "Німеччина",
        contactPersonPlaceholder: "Сашко Шевченко (необов'язково)",
        companyNamePlaceholder: "Приклад ТОВ (необов'язково)",
        dateAndTimePlaceholder: "ДД.ММ.РРРР ГГ:ХХ",
        email: "Ел. пошта (необов'язково)",
        phone: "Телефон (необов'язково)",
        mobile: "Мобільний (необов'язково)",
      },
      destinationLocation: {
        title: "Місце призначення",
        description: "Будь ласка, надайте інформацію про місце призначення транспорту.",
        streetNumber: "Вулиця та номер",
        postalCode: "Поштовий індекс",
        city: "Місто",
        country: "Країна",
        contactPerson: "Контактна особа на місці (необов'язково)",
        companyName: "Назва компанії (необов'язково)",
        date: "Дата доставки",
        dateTooEarly: "Дата доставки не може бути раніше дати забору {minDate}.",
        time: "Час (необов'язково)",
        streetNumberPlaceholder: "вул. Прикладна, 1",
        postalCodePlaceholder: "01001",
        cityPlaceholder: "Прикладоград",
        countryPlaceholder: "Німеччина",
        contactPersonPlaceholder: "Сашко Шевченко (необов'язково)",
        companyNamePlaceholder: "Приклад ТОВ (необов'язково)",
        dateAndTimePlaceholder: "ДД.ММ.РРРР ГГ:ХХ",
      },
      vehicleDetails: {
        title: "Деталі транспортного засобу",
        description: "Будь ласка, надайте інформацію про транспортний засіб.",
        vehicleMake: "Марка",
        vehicleModel: "Модель",
        vehicleColor: "Колір",
        vehicleLicensePlate: "Номерний знак",
        chassisNumber: "Номер шасі (необов'язково)",
        chassisNumberPlaceholder: "Введіть номер шасі",
        vehicleType: "Тип транспортного засобу",
        tireType: "Тип шин",
        tireTypeSelect: "Невідомо",
        tireTypeAllwetter: "Всесезонні",
        tireTypeSommer: "Літні",
        tireTypeWinter: "Зимові",
        vehicleTypeOptions: {
          car: "Автомобіль",
          van: "Фургон до 3,5 т",
          lightTruck: "Легкий вантажівка до 7,5 т",
          truck: "Вантажівка від 7,5 т",
          motorcycle: "Мотоцикл",
          rv: "Кемпер",
          lightTrailer: "Причіп до 750 кг",
          trailer: "Причіп понад 750 кг",
          bus: "Автобус",
        },
        vehicleWorth: "Вартість транспортного засобу",
        vehicleWorthOptions: {
          pleasSelect: "Будь ласка, оберіть",
          under80: "Менше 80 000 €",
          over80: "Понад 80 000 €",
        },
        vehicleRegistered: "Транспортний засіб зареєстровано?",
        vehicleAdditonalServices: "Додаткові послуги",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Червоні номери",
          basicDetailing: "Зовнішня мийка та пилосос",
          interiorDetailing: "Прибирання салону",
          vehicleTeaching: "Інструктаж з автомобіля",
          vehicleStorage: "Зберігання транспортного засобу",
        },
        vehicleColorPlaceHolder: "напр. Синій",
        vehicleLicensePlatePlaceHolder: "напр. А123ВС 77",
      },
      orderSummary: {
        title: "Підсумок",
        description: "Ви ввели всі необхідні дані і тепер можете оформити замовлення. Зверніть увагу, що показана ціна є приблизною. Можуть додаватися додаткові витрати за очікування або пальне.",
        submitOrder: "Надіслати замовлення (платеж)",
        submitRequest: "Надіслати запит",
        createAccountNow: "Створіть обліковий запис, щоб завершити замовлення.",
        requestOnly: "Ціна за запитом",
        emailVerification: "Посилання для підтвердження було надіслано на вашу електронну адресу. Перевірте також папку спам. Очікування підтвердження...",
        invoiceRecipientSameAsCustomer: "Отримувач рахунку такий же, як замовник",
        companyName: "Компанія",
        contactPerson: "Контактна особа",
        streetNumber: "Вулиця та номер",
        zip: "Поштовий індекс",
        city: "Місто",
        country: "Країна",
        name: "Ім'я",
        customerNote: "Примітки (необов'язково)",
        customerNotePlaceholder: "Тут ви можете залишити додаткову інформацію або побажання до вашого замовлення...",
        details: "Деталі",
      },
      priceCalculation: {
        total: "Приблизна загальна ціна*",
        item: "Позиція",
        amount: "Кількість",
        itemTotal: "Всього (з ПДВ)",
        additionalMwst: "включно з {amount} ПДВ",
        disclaimer: "У вартість перегону входить послуга електронного журналу подорожі, детальна фотодокументація автомобіля, а також оцінка пошкоджень\n\n*Усі ціни не включають додаткові витрати на паливо, дорожні збори, мастильні матеріли та час очікування. Правила щодо часу очікування див. в Умовах надання послуг."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Відсутня контактна інформація",
        message: "Ви не вказали контактну інформацію для місця забору або доставки. Бажаєте ввести цю інформацію зараз?",
        yesText: "Ввести зараз",
        noText: "Продовжити без введення"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "Чи зобов’язує калькулятор цін до укладання договору?",
        answer: "У кінці калькулятора цін ви можете вирішити надіслати замовлення. Надсилаючи замовлення, ви укладаєте обов’язковий договір. Використання калькулятора лише для оцінки вартості, без надсилання замовлення, є добровільним і не обов’язковим.",
      },
      moreHelpNeeded: {
        question: "Потрібна додаткова допомога або послуги?",
        answer: "Ви можете зв’язатися з нами в будь‑який час за адресою info@cuno.gmbh або за телефоном +49 30 20 89 80 4‑0."
      }
    },
    cookieConsent: {
      title: "Налаштування cookie",
      explanation: "Ми використовуємо файли cookie, щоб забезпечити найкращий досвід користування нашим сайтом. Деякі файли cookie необхідні, інші допомагають покращити наші послуги. Також ми використовуємо Recaptcha V3 (Google) для захисту від спаму. Більше інформації у нашій Політиці конфіденційності та Імпресумі.",
      accept: "Прийняти",
      decline: "Відхилити",
    }
  },
  es: {
    priceCalculator: "Calculadora de precios",
    priceCalculatorDescrption: "Utilice el formulario a continuación para calcular el costo de su solicitud de transporte.",
    loginGreeding: "Bienvenido/a de nuevo, {UserName}",
    logout: "Cerrar sesión",
    success: "Pedido enviado correctamente. Si tenemos alguna pregunta, nos pondremos en contacto contigo.",
    successRequest: "Solicitud enviada correctamente. Nos pondremos en contacto contigo lo antes posible.",
    successTitle: "Pedido Enviado",
    errorTitle: "Error al Enviar Pedido",
    error: "Error al enviar el pedido. Contacte con info@cuno.gmbh.",
    userAlreadyExists: "El usuario ya existe, por favor inicie sesión",
    recaptchaFailed: "Verificación Recaptcha falló, por favor actualice la página e inténtelo más tarde.",
    unknownError: "Error desconocido. Por favor, inténtelo más tarde.",
    form: {
      valuemissing: "{ValueName} es necesario",
      back: "Atrás",
      continue: "Continuar",
      haveAccount: "¿Ya tienes cuenta de cliente? Inicia sesión",
      createAccount: "¿Aún no tienes cuenta? Créala",
      login: "Iniciar sesión",
      contactData: {
        passwordConfirm: "Confirmar contraseña",
        passwordMatch: "Las contraseñas no coinciden",
        passwordLength: "La contraseña debe tener al menos 7 caracteres",
        country: "País",
        password: "Contraseña",
        zip: "Código postal",
        city: "Ciudad",
        title: "Información de contacto",
        description: "Por favor, proporcione algunos datos sobre usted.",
        descriptionLoggedIn: "Por favor, verifique su información de contacto existente.",
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Correo electrónico",
        phone: "Teléfono",
        address: "Dirección",
        firstNamePlaceholder: "Alex",
        lastNamePlaceholder: "López",
        emailPlaceholder: "alex.lopez@example.es",
        phonePlaceholder: "+34 612 345 678",
        addressPlaceholder: "Calle Falsa 123, 28013 Madrid",
      },
      pickupLocation: {
        title: "Lugar de recogida",
        description: "Por favor, proporcione información sobre la recogida del vehículo.",
        streetNumber: "Calle y número",
        postalCode: "Código postal",
        city: "Ciudad",
        country: "País",
        contactPerson: "Persona de contacto en el lugar (opcional)",
        companyName: "Nombre de la empresa (opcional)",
        date: "Fecha de recogida",
        dateTooEarly: "La fecha más temprana de recogida es {minDate}.",
        time: "Hora (opcional)",
        streetNumberPlaceholder: "Calle Ejemplo 1",
        postalCodePlaceholder: "28001",
        cityPlaceholder: "Ciudad Ejemplo",
        countryPlaceholder: "Alemania",
        contactPersonPlaceholder: "Andrea García (opcional)",
        companyNamePlaceholder: "Ejemplo S.L. (opcional)",
        dateAndTimePlaceholder: "DD/MM/AAAA HH:MM",
        email: "Correo electrónico (opcional)",
        phone: "Teléfono (opcional)",
        mobile: "Móvil (opcional)",
      },
      destinationLocation: {
        title: "Destino",
        description: "Por favor, proporcione información sobre el destino del transporte.",
        streetNumber: "Calle y número",
        postalCode: "Código postal",
        city: "Ciudad",
        country: "País",
        contactPerson: "Persona de contacto en el lugar (opcional)",
        companyName: "Nombre de la empresa (opcional)",
        date: "Fecha de entrega",
        dateTooEarly: "La fecha de entrega no puede ser anterior a la fecha de recogida.",
        time: "Hora (opcional)",
        streetNumberPlaceholder: "Calle Ejemplo 1",
        postalCodePlaceholder: "28001",
        cityPlaceholder: "Ciudad Ejemplo",
        countryPlaceholder: "Alemania",
        contactPersonPlaceholder: "Andrea García (opcional)",
        companyNamePlaceholder: "Ejemplo S.L. (opcional)",
        dateAndTimePlaceholder: "DD/MM/AAAA HH:MM",
      },
      vehicleDetails: {
        title: "Detalles del vehículo",
        description: "Por favor, proporcione información sobre el vehículo.",
        vehicleMake: "Marca",
        vehicleModel: "Modelo",
        vehicleColor: "Color",
        vehicleLicensePlate: "Matrícula",
        chassisNumber: "Número de chasis (opcional)",
        chassisNumberPlaceholder: "Ingrese número de chasis",
        vehicleType: "Tipo de vehículo",
        tireType: "Tipo de neumático",
        tireTypeSelect: "Desconocido",
        tireTypeAllwetter: "Todo tiempo",
        tireTypeSommer: "Verano",
        tireTypeWinter: "Invierno",
        vehicleTypeOptions: {
          car: "Coche",
          van: "Furgoneta hasta 3,5 T",
          lightTruck: "Camión ligero hasta 7,5 T",
          truck: "Camión desde 7,5 T",
          motorcycle: "Motocicleta",
          rv: "Autocaravana",
          lightTrailer: "Remolque hasta 750 kg",
          trailer: "Remolque más de 750 kg",
          bus: "Autobús",
        },
        vehicleWorth: "Valor del vehículo",
        vehicleWorthOptions: {
          pleasSelect: "Por favor seleccione",
          under80: "Menos de € 80 000",
          over80: "Más de € 80 000",
        },
        vehicleRegistered: "¿Está registrado el vehículo?",
        vehicleAdditonalServices: "Servicios adicionales",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Placas rojas",
          basicDetailing: "Lavado exterior y aspirado",
          interiorDetailing: "Limpieza interior",
          vehicleTeaching: "Instrucción del vehículo",
          vehicleStorage: "Almacenamiento del vehículo",
        },
        vehicleColorPlaceHolder: "p. ej. Azul",
        vehicleLicensePlatePlaceHolder: "p. ej. 12-34-AB",
      },
      orderSummary: {
        title: "Resumen",
        description: "Ha ingresado todos los datos necesarios y ahora puede enviar su pedido. Tenga en cuenta que el precio total mostrado es una estimación. Pueden aplicarse costos adicionales por tiempo de espera o combustible.",
        submitOrder: "Enviar pedido (con pago)",
        submitRequest: "Enviar consulta",
        createAccountNow: "Cree ahora una cuenta de cliente para completar el pedido.",
        requestOnly: "Precio bajo consulta",
        emailVerification: "Se ha enviado un enlace de confirmación a su dirección de correo electrónico. También revise su carpeta de spam. Esperando verificación de correo electrónico...",
        invoiceRecipientSameAsCustomer: "Destinatario de factura igual que cliente",
        companyName: "Empresa",
        contactPerson: "Persona de contacto",
        streetNumber: "Calle y número",
        zip: "Código postal",
        city: "Ciudad",
        country: "País",
        name: "Nombre",
        customerNote: "Observaciones (opcional)",
        customerNotePlaceholder: "Aquí puede dejar información adicional o solicitudes para su pedido...",
        details: "Detalles",
      },
      priceCalculation: {
        total: "Precio total estimado*",
        item: "Ítem",
        amount: "Cantidad",
        itemTotal: "Total (IVA incluido)",
        additionalMwst: "incl. {amount} IVA",
        disclaimer: "El precio de traslado incluye el servicio de un registro electrónico de viaje, documentación fotográfica detallada del vehículo así como evaluación de daños\n\n*Todos los precios están sujetos a costos adicionales de combustible, peajes, lubricantes y tiempos de espera. Para las regulaciones sobre tiempos de espera, consulte los Términos y Condiciones."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Información de contacto faltante",
        message: "No has proporcionado información de contacto para el lugar de recogida o destino. ¿Te gustaría ingresar esta información ahora?",
        yesText: "Ingresar ahora",
        noText: "Continuar sin ingresar"
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "¿El calculador de precios me obliga a contratar?",
        answer: "Al final del calculador de precios puede decidir enviar un pedido. Al enviarlo, usted acepta un contrato vinculante. El uso solamente para estimar costos, sin enviar pedido, es voluntario y no vinculante.",
      },
      moreHelpNeeded: {
        question: "¿Necesita más ayuda o servicios?",
        answer: "Puede contactarnos en cualquier momento por info@cuno.gmbh o llamando al +49 30 20 89 80 4‑0."
      }
    },
    cookieConsent: {
      title: "Configuración de cookies",
      explanation: "Utilizamos cookies para brindarte la mejor experiencia posible en nuestro sitio web. Algunas cookies son necesarias, mientras que otras nos ayudan a mejorar nuestros servicios. También utilizamos Recaptcha V3 (Google) para proteger contra el spam. Para más información, consulta nuestra Política de privacidad y el Aviso legal.",
      accept: "Aceptar",
      decline: "Rechazar",
    }
  },
  pt: {
    priceCalculator: "Calculadora de preços",
    priceCalculatorDescrption: "Use o formulário abaixo para calcular o custo de sua solicitação de transporte.",
    loginGreeding: "Bem-vindo(a) de volta, {UserName}",
    logout: "Sair",
    success: "Pedido enviado com sucesso. Se tivermos alguma dúvida, entraremos em contacto consigo.",
    successRequest: "Solicitação enviada com sucesso. Entraremos em contacto consigo o mais breve possível.",
    successTitle: "Pedido Enviado",
    errorTitle: "Erro ao Enviar Pedido",
    error: "Erro ao enviar o pedido. Entre em contacto com info@cuno.gmbh.",
    form: {
      valuemissing: "{ValueName} é obrigatório",
      back: "Voltar",
      continue: "Continuar",
      haveAccount: "Já tem uma conta de cliente? Inicie sessão",
      createAccount: "Ainda não tem conta? Crie uma",
      login: "Login",
      contactData: {
        passwordConfirm: "Confirmar senha",
        passwordMatch: "As senhas não coincidem",
        passwordLength: "A senha deve ter pelo menos 7 caracteres",
        country: "País",
        password: "Senha",
        zip: "Código postal",
        city: "Cidade",
        title: "Informações de contato",
        description: "Por favor, forneça algumas informações sobre você.",
        descriptionLoggedIn: "Por favor, verifique suas informações de contato existentes.",
        firstName: "Nome",
        lastName: "Sobrenome",
        email: "E‑mail",
        phone: "Telefone",
        address: "Endereço",
        firstNamePlaceholder: "Alex",
        lastNamePlaceholder: "Ferreira",
        emailPlaceholder: "alex.ferreira@example.pt",
        phonePlaceholder: "+351 912 345 678",
        addressPlaceholder: "Rua das Flores 10, 1250-096 Lisboa",
      },
      pickupLocation: {
        title: "Local de retirada",
        description: "Por favor, forneça informações sobre a retirada do veículo.",
        streetNumber: "Rua e número",
        postalCode: "Código postal",
        city: "Cidade",
        country: "País",
        contactPerson: "Pessoa de contato no local (opcional)",
        companyName: "Nome da empresa (opcional)",
        date: "Data da retirada",
        dateTooEarly: "A data mais cedo para retirada é {minDate}.",
        time: "Horário (opcional)",
        streetNumberPlaceholder: "Rua Exemplo 1",
        postalCodePlaceholder: "1000-001",
        cityPlaceholder: "Exemplópolis",
        countryPlaceholder: "Alemanha",
        contactPersonPlaceholder: "Rafa Silva (opcional)",
        companyNamePlaceholder: "Exemplo Lda. (opcional)",
        dateAndTimePlaceholder: "DD/MM/AAAA HH:MM",
        email: "E-mail (opcional)",
        phone: "Telefone (opcional)",
        mobile: "Telemóvel (opcional)",
      },
      destinationLocation: {
        title: "Destino",
        description: "Por favor, forneça informações sobre o destino do transporte.",
        streetNumber: "Rua e número",
        postalCode: "Código postal",
        city: "Cidade",
        country: "País",
        contactPerson: "Pessoa de contato no local (opcional)",
        companyName: "Nome da empresa (opcional)",
        date: "Data da entrega",
        dateTooEarly: "A data de entrega não pode ser anterior à data de retirada {minDate}.",
        time: "Horário (opcional)",
        streetNumberPlaceholder: "Rua Exemplo 1",
        postalCodePlaceholder: "1000-001",
        cityPlaceholder: "Exemplópolis",
        countryPlaceholder: "Alemanha",
        contactPersonPlaceholder: "Rafa Silva (opcional)",
        companyNamePlaceholder: "Exemplo Lda. (opcional)",
        dateAndTimePlaceholder: "DD/MM/AAAA HH:MM",
      },
      vehicleDetails: {
        title: "Detalhes do veículo",
        description: "Por favor, forneça informações sobre o veículo.",
        vehicleMake: "Marca",
        vehicleModel: "Modelo",
        vehicleColor: "Cor",
        vehicleLicensePlate: "Placa",
        chassisNumber: "Número do chassi (opcional)",
        chassisNumberPlaceholder: "Digite o número do chassi",
        vehicleType: "Tipo de veículo",
        tireType: "Tipo de pneu",
        tireTypeSelect: "Desconhecido",
        tireTypeAllwetter: "Todas as estações",
        tireTypeSommer: "Verão",
        tireTypeWinter: "Inverno",
        vehicleTypeOptions: {
          car: "Carro",
          van: "Van até 3,5 T",
          lightTruck: "Caminhão leve até 7,5 T",
          truck: "Caminhão a partir de 7,5 T",
          motorcycle: "Motocicleta",
          rv: "Motor‑home",
          lightTrailer: "Reboque até 750 kg",
          trailer: "Reboque acima de 750 kg",
          bus: "Ônibus",
        },
        vehicleWorth: "Valor do veículo",
        vehicleWorthOptions: {
          pleasSelect: "Por favor selecione",
          under80: "Menos de € 80 000",
          over80: "Mais de € 80 000",
        },
        vehicleRegistered: "O veículo está registrado?",
        vehicleAdditonalServices: "Serviços adicionais",
        vehicleAdditonalServicesOptions: {
          redLicensePlates: "Placas vermelhas",
          basicDetailing: "Lavagem exterior e aspiração",
          interiorDetailing: "Limpeza interna",
          vehicleTeaching: "Introdução ao veículo",
          vehicleStorage: "Armazenamento de veículo",
        },
        vehicleColorPlaceHolder: "ex. Azul",
        vehicleLicensePlatePlaceHolder: "ex. 12-34-AB",
      },
      orderSummary: {
        title: "Resumo",
        description: "Você inseriu todos os dados necessários e agora pode enviar seu pedido. Observe que o preço total mostrado é uma estimativa. Custos adicionais podem ser aplicados por espera ou combustível.",
        submitOrder: "Enviar pedido (com pagamento)",
        submitRequest: "Enviar solicitação",
        createAccountNow: "Crie agora uma conta de cliente para concluir o pedido.",
        requestOnly: "Preço sob consulta",
        emailVerification: "Um link de confirmação foi enviado para o seu e-mail. Verifique também a pasta de spam. Aguardando verificação...",
        invoiceRecipientSameAsCustomer: "Destinatário da fatura igual ao cliente",
        companyName: "Empresa",
        contactPerson: "Pessoa de contacto",
        streetNumber: "Rua e número",
        zip: "Código postal",
        city: "Cidade",
        country: "País",
        name: "Nome",
        customerNote: "Observações (opcional)",
        customerNotePlaceholder: "Aqui pode deixar informações adicionais ou solicitações para o seu pedido...",
        details: "Detalhes",
      },
      priceCalculation: {
        total: "Preço total estimado*",
        item: "Item",
        amount: "Quantidade",
        itemTotal: "Total (IVA incluído)",
        additionalMwst: "incl. {amount} IVA",
        disclaimer: "O preço de transferência inclui o serviço de um registo eletrónico de viagem, documentação fotográfica detalhada do veículo bem como avaliação de danos\n\n*Todos os preços estão sujeitos a custos adicionais de combustível, portagens, lubrificantes e tempos de espera. Para regulamentações sobre tempos de espera, consulte os Termos e Condições."
      }
    },
    dialog: {
      missingContactDataDialog: {
        title: "Configurações de Cookies",
        message: "Usamos cookies para oferecer a melhor experiência possível em nosso site. Alguns cookies são necessários, enquanto outros nos ajudam a melhorar nossos serviços. Também utilizamos o Recaptcha V3 (Google) para proteção contra spam. Para mais informações, consulte nossa Política de Privacidade e Impressum.",
        accept: "Aceitar",
        decline: "Recusar",
      }
    },
    faq: {
      isMandatoryOrder: {
        question: "O calculador de preços me obriga a celebrar um contrato?",
        answer: "No final do calculador de preços, você pode decidir enviar um pedido. Ao enviá‑lo, você entra em um contrato vinculativo. Usar apenas para estimar custos, sem enviar o pedido, é voluntário e não vinculativo.",
      },
      moreHelpNeeded: {
        question: "Precisa de mais ajuda ou serviços?",
        answer: "Você pode nos contatar a qualquer momento através do info@cuno.gmbh ou ligando para +49 30 20 89 80 4‑0."
      }
    },
    cookieConsent: {
      title: "Configurações de Cookies",
      explanation: "Usamos cookies para oferecer a melhor experiência possível em nosso site. Alguns cookies são necessários, enquanto outros nos ajudam a melhorar nossos serviços. Também utilizamos o Recaptcha V3 (Google) para proteção contra spam. Para mais informações, consulte nossa Política de Privacidade e Impressum.",
      accept: "Aceitar",
      decline: "Recusar",
    }
  }
});

/**
 * State of the localization
 * @property {string} language: Language code of current language
 */
interface LocalizationState {
  language?: string;
}

const initialState: LocalizationState = {
    language: undefined
}

export const localizationSlice = createSlice({
    name: 'localization',
    initialState,
    reducers: {
        setLanguage: (state, action) => {
          const baseLanguage = action.payload.split('-')[0]; 
          if(strings.getAvailableLanguages().includes(baseLanguage)) {
            strings.setLanguage(baseLanguage)
            state.language = baseLanguage
          } else {
            strings.setLanguage('en')
            state.language = 'en'
          }
        },
        setLanguageToDeviceLanguageIfPossible: (state) => {
          const deviceLanguage = strings.getInterfaceLanguage();
          const baseLanguage = deviceLanguage.split('-')[0]; 

          if(strings.getAvailableLanguages().includes(baseLanguage)) {
            strings.setLanguage(baseLanguage)
            state.language = baseLanguage
          } else {
            strings.setLanguage('en')
            state.language = 'en'
          }
        }
    },
})

export default strings
export const { setLanguage, setLanguageToDeviceLanguageIfPossible } = localizationSlice.actions
export const localizationReducer = localizationSlice.reducer
export const selectLanguage = (state: RootState) => state.localization.language